var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-icon',{staticClass:"mr-1",attrs:{"color":_vm.color,"small":""}},[_vm._v("mdi-comment"+_vm._s(_vm.replied ? "-multiple" : ""))])
}
var staticRenderFns = []

export { render, staticRenderFns }